/** @public */
export enum PermissionResponse {
    GRANTED = 'granted',
    DENIED = 'denied',
    DISMISSED = 'dismissed',
    DEFAULT = 'default',
}

/** @internal */
export function permissionResponseFromNotificationPermission(permission: NotificationPermission): PermissionResponse {
    switch (permission) {
        case 'granted':
            return PermissionResponse.GRANTED
        case 'denied':
            return PermissionResponse.DENIED
        default:
            return PermissionResponse.DEFAULT
    }
}
